import CloseIcon from 'Component/CloseIcon';
import { ResetButton as SourceResetButton } from 'SourceComponent/ResetButton/ResetButton.component';

import './ResetButton.override.style';

/** @namespace AdvoxBasic/Component/ResetButton/Component/ResetButton */
export class ResetButton extends SourceResetButton {
    render() {
        const { mix, isContentFiltered } = this.props;

        if (!isContentFiltered) {
            return null;
        }

        return (
            <button block="ResetButton" mix={mix} onClick={this.onClick}>
                <div block="ResetButton" elem="Label">
                    {__('Clear filters')}
                </div>
                <span block="ResetButton" elem="CloseIcon">
                    <CloseIcon />
                </span>
            </button>
        );
    }
}

export default ResetButton;
